import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import flyerImage from './assets/persian-palate-flyer.jpeg'; // Adjust the path to your image
import menuPdf from './assets/persian_palate_menu.pdf'; // Add this import

function Home() {
  return (
    <div className="image-container">
      <img src={flyerImage} alt="Persian Palate Design" className="mobile-image" />
    </div>
  );
}

function QRRedirect() {
  // Detect browser and device type
  const userAgent = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
  const isMobileSafari = isIOS && isSafari;
  
  // For iOS Safari specifically, use direct redirect as it handles PDFs better
  if (isMobileSafari) {
    window.location.href = menuPdf;
    return <div style={{ padding: '20px', textAlign: 'center' }}>Redirecting to menu...</div>;
  }
  
  // For all other devices (Android, desktop, etc.), use iframe
  return (
    <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
      <iframe
        src={menuPdf}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="Menu PDF"
      />
      {/* Fallback link */}
      <div style={{ 
        position: 'absolute', 
        bottom: '20px', 
        left: '50%', 
        transform: 'translateX(-50%)',
        backgroundColor: 'rgba(0,0,0,0.8)',
        color: 'white',
        padding: '10px 20px',
        borderRadius: '5px'
      }}>
        <a 
          href={menuPdf} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: 'white', textDecoration: 'none' }}
        >
          Can't see the menu? Click here to open PDF
        </a>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/qr" element={<QRRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;